/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendPdfToUsersCommandResult } from '../../models/send-pdf-to-users-command-result';

export interface ApiPlanSendPdfToUsersPost$Plain$Params {
      body?: {
'PdfFile': Blob;
'UserIds': Array<string>;
}
}

export function apiPlanSendPdfToUsersPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanSendPdfToUsersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SendPdfToUsersCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanSendPdfToUsersPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SendPdfToUsersCommandResult>;
    })
  );
}

apiPlanSendPdfToUsersPost$Plain.PATH = '/api/Plan/SendPdfToUsers';
